/**
 * Progress tracker using spinners for rich terminal output
 */

import { ProgressTracker } from '@/types';
import { createSpinner, type Spinner } from './ui';

/**
 * Animated progress tracker with ora spinners
 */
export class SpinnerProgressTracker implements ProgressTracker {
  private spinner: Spinner | null = null;

  start(message: string): void {
    this.spinner = createSpinner(message);
    this.spinner.start();
  }

  update(message: string): void {
    if (this.spinner) {
      this.spinner.text = message;
    }
  }

  succeed(message: string): void {
    if (this.spinner) {
      this.spinner.succeed(message);
      this.spinner = null;
    }
  }

  fail(message: string): void {
    if (this.spinner) {
      this.spinner.fail(message);
      this.spinner = null;
    }
  }

  warn(message: string): void {
    if (this.spinner) {
      this.spinner.warn(message);
      this.spinner = null;
    }
  }
}

/**
 * Factory to create a progress tracker
 */
export function createProgressTracker(): ProgressTracker {
  return new SpinnerProgressTracker();
}
